import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const EntitiesView = angular
  .module('acme.view.application.entities', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.view.application.entities.list',
    'acme.view.application.entities.create',
    'acme.view.application.entities.detail',
    'acme.view.application.entities.templates',
    'acme.view.application.entities.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const entities = {
      name: 'application.entities',
      url: '/entities',
      views: {
        'subview-main': {
          controller: 'EntitiesController',
          templateUrl: 'views/application/views/entities/entities.tpl.html',
        },
      },
      data: {
        pageTitle: '',
        pageClass: 'application',
      },
    };

    $stateProvider.state(entities);
  }).name;
